import { Link } from '@reach/router';
import { LessonsActivity } from 'api/lessonsApi';
import useFullHeight from 'components/subjectSite/useFullHeight';
import React, { useRef } from 'react';
import LessonDownArrow from './LessonDownArrow';
import { activityImage } from './lessonsHelpers';

type Props = {
  activity: LessonsActivity;
  keyStageName: string;
  backPath: string;
  /**
   * The line under the title, such as "Unit of Work" or "Lesson 2 - Theme"
   */
  lessonLine: string;
  onPrint: () => void;
  /**
   * Shown under the Print button
   */
  printError?: React.ReactNode;
};

/**
 * The unit of work and lesson plan hero: Back, year chip, title, the line under it, Print and the
 * activity image, then anything passed, such as the previous and next lesson links
 */
const LessonDetailTop: React.FC<Props> = ({
  activity,
  keyStageName,
  backPath,
  lessonLine,
  onPrint,
  printError,
  children,
}) => {
  const blockRef = useRef<HTMLDivElement>(null);
  const image = activityImage(activity);

  useFullHeight(blockRef);

  return (
    <div className="Top">
      <div className="WidthContent">
        <div className="Table_Inner ContainerFixed" ref={blockRef}>
          <div className="Cell_Inner">
            <Link to={backPath} className="BtnFour BtnBack">
              <span className="Icon_Four"></span>
              <span className="Txt_Four">Back</span>
            </Link>
            <div className="Table">
              <div className="Desc">
                <div className="ImgHidden">
                  <img src={image} alt={activity.name} />
                </div>
                <div className="Year">{keyStageName}</div>
                <h1 className="Title">{activity.name}</h1>
                <div className="Lesson">{lessonLine}</div>
                <div className="BtnTwo BtnPrint">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      onPrint();
                    }}
                  >
                    Print
                  </a>
                </div>
                {printError}
              </div>
              <div className="Img">
                <img src={image} alt={activity.name} />
              </div>
            </div>
          </div>
        </div>
        {children}
        <LessonDownArrow />
      </div>
    </div>
  );
};

export default LessonDetailTop;
